<template>
  <div class="alert alert-info">
    <div class="col-md-12">
      <div class="row">
        <div class="col-sm-1 col-md-1">
          <span
            class="icon-check"
            :class="[
              uppercase
                ? 'glyphicon glyphicon-ok passed'
                : 'glyphicon glyphicon-remove no-passed',
            ]"
          >
          </span>
        </div>
        <div class="col-sm-5 col-md-5 text-rule-container">
          <span class="text-rule"> Password must have an uppercase. </span>
        </div>

        <div class="col-sm-1 col-md-1">
          <span
            class="icon-check"
            :class="[
              matching
                ? 'glyphicon glyphicon-ok passed'
                : 'glyphicon glyphicon-remove no-passed',
            ]"
          >
          </span>
        </div>
        <div class="col-sm-5 col-md-5 text-rule-container">
          <span class="text-rule">
            Password and confirmation password must match.
          </span>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-1 col-md-1">
          <span
            class="icon-check"
            :class="[
              lowercase
                ? 'glyphicon glyphicon-ok passed'
                : 'glyphicon glyphicon-remove no-passed',
            ]"
          >
          </span>
        </div>
        <div class="col-sm-5 col-md-5 text-rule-container">
          <span class="text-rule"> Password must have a lowercase. </span>
        </div>

        <div class="col-sm-1 col-md-1">
          <span
            class="icon-check"
            :class="[
              symbol
                ? 'glyphicon glyphicon-ok passed'
                : 'glyphicon glyphicon-remove no-passed',
            ]"
          >
          </span>
        </div>
        <div class="col-sm-5 col-md-5 text-rule-container">
          <span class="text-rule"> Password must have a symbol. </span>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-1 col-md-1">
          <span
            class="icon-check"
            :class="[
              amount
                ? 'glyphicon glyphicon-ok passed'
                : 'glyphicon glyphicon-remove no-passed',
            ]"
          >
          </span>
        </div>
        <div class="col-sm-5 col-md-5 text-rule-container">
          <span class="text-rule">
            Passwords must be at least 8 characters long.
          </span>
        </div>

        <div class="col-sm-1 col-md-1">
          <span
            class="icon-check"
            :class="[
              digits
                ? 'glyphicon glyphicon-ok passed'
                : 'glyphicon glyphicon-remove no-passed',
            ]"
          >
          </span>
        </div>
        <div class="col-sm-5 col-md-5 text-rule-container">
          <span class="text-rule"> Password must have a number. </span>
        </div>
      </div>
    </div>
    <div class="clearfix"></div>
  </div>
</template>
<script>
export default {
  computed: {
    uppercase() {
      return this.$store.state.registration.uppercase;
    },
    lowercase() {
      return this.$store.state.registration.lowercase;
    },
    digits() {
      return this.$store.state.registration.digits;
    },
    symbol() {
      return this.$store.state.registration.symbol;
    },
    matching() {
      return this.$store.state.registration.matching;
    },
    amount() {
      return this.$store.state.registration.amount;
    },
  },
};
</script>
